import { getAccessToken } from "../../auth/verifyAuth";

async function getPayboxParameters(msalInstance, variables, candidature, questionId, contactId, formBuyer) {
    var accessToken = await getAccessToken(msalInstance, variables);
    return fetch(window.location.origin + "/api/v2.0/payboxurl", {
        method: "POST",
        headers: {
            "my-Authorization": `Bearer ${accessToken}`,
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...formBuyer,
            candidature : candidature,
            contactId : contactId,
            questionId : questionId
        })
    })
}

export {
    getPayboxParameters
}